<template>
  <div class="d-flex">
    <div class="left avatar shine mr-2 flex-shrink-0"></div>
    <div class="right d-flex flex-column">
      <div class="title shine"></div>
      <div class="entity shine"></div>
      <div class="content shine"></div>
    </div>
  </div>
</template>

<script>
/**
 * This is the skeleton loader for notification
 */
export default {
  name: 'NotificationSkeleton'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.avatar {
  @include dimension(50px, 50px);
  border-radius: 50%;
  margin-left: 45px;
}
.title {
  height: 13px;
  width: 200px;
  border-radius: 6px;
  margin-bottom: 6px;
}
.entity {
  height: 13px;
  width: 230px;
  border-radius: 6px;
}
.content {
  height: 14px;
  width: 270px;
  border-radius: 6px;
  margin-top: 20px;
}
.right {
  margin: 20px 0;
}
.left {
  margin-top: 10px;
}
</style>
